import { defineStore } from 'pinia'
import { useSyncableModel } from '@/composables/useSyncableModel.js'
import { useApiResource } from '@/composables/resources/useApiResource.js'
import TrainingCourse from '@/models/TrainingCourse.js'

export const useTrainingCourseStore = defineStore('trainingCourseStore', () => {
  let syncableModel = useSyncableModel(useApiResource('training_courses'), {
    className: TrainingCourse.modelName.name,
    paramKey: TrainingCourse.modelName.paramKey
  })


  async function reloadDocuments(uuid) {
    let response = await syncableModel.resource.get(uuid)

    const trainingCourse = response.data
    let course = syncableModel.collection.value.find((item) => item.uuid == uuid)
    course = Object.assign(course, {documents: trainingCourse.documents})
    return course
  }

  function $reset() {
    syncableModel.collection.value = []
  }

  return {
    ...syncableModel,
    reloadDocuments,
    $reset
  }

}, {
  persist: true
})

